module.exports = __webpack_public_path__ + "static/media/mc_front_closed.9638b43d.svg";